// extracted by mini-css-extract-plugin
export default {"sigsettingContent":"SignatureSetting_sigsettingContent__2yZ8E","dropdown":"SignatureSetting_dropdown__N3557"};